import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";
import SectionHeading from "@/components/feature/SectionHeading";

export default function NewsPreview() {
  const featured = newsList[0];
  const rest = newsList.slice(1, 5);

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="mx-auto w-full max-w-[1400px] px-4 md:px-8">
        <SectionHeading
          kicker="Anime newsroom"
          title="最新动漫资讯快讯"
          description="新番片单、行业观察、深度评测与线下活动，编辑部每天更新，帮你跟上圈子里的节奏。"
          linkTo="/news"
          linkLabel="进入资讯频道"
        />

        <div className="grid grid-cols-1 gap-6 lg:grid-cols-[1.05fr_1fr]">
          <Link
            to={`/news/${featured.id}`}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
          >
            <div className="relative aspect-[16/9] w-full overflow-hidden bg-background-200">
              <img
                src={featured.cover}
                alt={`${featured.title} 资讯封面`}
                title={`${featured.title} - 动漫资讯`}
                className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-[1.03]"
              />
              <span className="absolute left-3 top-3 rounded bg-primary-500 px-2 py-0.5 font-label text-[11px] text-background-50">
                {featured.category}
              </span>
            </div>
            <div className="flex flex-1 flex-col p-5">
              <h3 className="text-lg font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                {featured.title}
              </h3>
              <p className="mt-2 line-clamp-2 text-sm leading-relaxed text-foreground-600">{featured.excerpt}</p>
              <div className="mt-auto flex items-center gap-3 pt-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1">
                  <i className="ri-user-3-line" />
                  {featured.author}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-time-line" />
                  {featured.date}
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line" />
                  {featured.views}
                </span>
              </div>
            </div>
          </Link>

          <div className="flex flex-col gap-3">
            {rest.map((item) => (
              <Link
                key={item.id}
                to={`/news/${item.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-200"
              >
                <div className="relative h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 sm:h-24 sm:w-36">
                  <img
                    src={item.cover}
                    alt={`${item.title} 资讯封面`}
                    title={`${item.title} - 资讯`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2">
                    <span className="rounded bg-secondary-100 px-1.5 py-0.5 font-label text-[10px] text-secondary-900">
                      {item.category}
                    </span>
                    <span className="font-label text-[11px] text-foreground-500">{item.date}</span>
                  </div>
                  <h3 className="mt-1.5 line-clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                  <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{item.excerpt}</p>
                </div>
              </Link>
            ))}
            <Link
              to="/news"
              className="flex items-center justify-center gap-1 whitespace-nowrap rounded-lg border border-dashed border-background-300 py-3 text-sm text-foreground-600 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              浏览更多资讯
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}